import {createGlobalStyle} from 'styled-components';

export const TranslucentColorStyles = createGlobalStyle`
  :root {
    --color-translucent-blue10: rgba(79, 67, 221, 0.10);
    --color-translucent-blue12: rgba(79, 67, 221, 0.12);
    --color-translucent-blue15: rgba(79, 67, 221, 0.15);
    --color-translucent-blue20: rgba(79, 67, 221, 0.20);
    --color-translucent-blue25: rgba(79, 67, 221, 0.25);
    --color-translucent-blue30: rgba(79, 67, 221, 0.30);
    --color-translucent-red12: rgba(210, 66, 53, 0.12);
    --color-translucent-red15: rgba(210, 66, 53, 0.15);
    --color-translucent-red20: rgba(210, 66, 53, 0.20);
    --color-translucent-red25: rgba(210, 66, 53, 0.25);
    --color-translucent-red30: rgba(210, 66, 53, 0.30);
    --color-translucent-yellow12: rgba(254, 163, 25, 0.12);
    --color-translucent-yellow15: rgba(254, 163, 25, 0.15);
    --color-translucent-yellow20: rgba(254, 163, 25, 0.20);
    --color-translucent-yellow25: rgba(254, 163, 25, 0.25);
    --color-translucent-yellow30: rgba(254, 163, 25, 0.30);
    --color-translucent-green12: rgba(46, 204, 129, 0.12);
    --color-translucent-green15: rgba(46, 204, 129, 0.15);
    --color-translucent-green20: rgba(46, 204, 129, 0.20);
    --color-translucent-green25: rgba(46, 204, 129, 0.25);
    --color-translucent-green30: rgba(46, 204, 129, 0.30);
    --color-translucent-lime12: rgba(81, 233, 124, 0.12);
    --color-translucent-lime15: rgba(81, 233, 124, 0.15);
    --color-translucent-lime20: rgba(81, 233, 124, 0.20);
    --color-translucent-lime25: rgba(81, 233, 124, 0.25);
    --color-translucent-lime30: rgba(81, 233, 124, 0.30);
    --color-translucent-olive12: rgba(156, 172, 151, 0.12);
    --color-translucent-olive15: rgba(156, 172, 151, 0.15);
    --color-translucent-olive20: rgba(156, 172, 151, 0.20);
    --color-translucent-olive25: rgba(156, 172, 151, 0.25);
    --color-translucent-olive30: rgba(156, 172, 151, 0.30);
    --color-translucent-cyan12: rgba(75, 180, 210, 0.12);
    --color-translucent-cyan15: rgba(75, 180, 210, 0.15);
    --color-translucent-cyan20: rgba(75, 180, 210, 0.20);
    --color-translucent-cyan25: rgba(75, 180, 210, 0.25);
    --color-translucent-cyan30: rgba(75, 180, 210, 0.30);
    --color-translucent-gray12: rgba(103, 116, 138, 0.12);
    --color-translucent-gray15: rgba(103, 116, 138, 0.15);
    --color-translucent-gray20: rgba(103, 116, 138, 0.20);
    --color-translucent-gray25: rgba(103, 116, 138, 0.25);
    --color-translucent-gray30: rgba(103, 116, 138, 0.30);
    --color-translucent-gray50: rgba(13, 17, 33, 0.50);
    --color-translucent-gray90: rgba(13, 17, 33, 0.90);
    --color-translucent-coral12: rgba(216, 26, 69, 0.12);
    --color-translucent-coral15: rgba(216, 26, 69, 0.15);
    --color-translucent-coral20: rgba(216, 26, 69, 0.20);
    --color-translucent-coral25: rgba(216, 26, 69, 0.25);
    --color-translucent-coral30: rgba(216, 26, 69, 0.30);
    --color-translucent-cobalt12: rgba(0, 97, 217, 0.12);
    --color-translucent-cobalt15: rgba(0, 97, 217, 0.15);
    --color-translucent-cobalt20: rgba(0, 97, 217, 0.20);
    --color-translucent-cobalt25: rgba(0, 97, 217, 0.25);
    --color-translucent-cobalt30: rgba(0, 97, 217, 0.30);
    --color-translucent-light-wash: rgba(247, 248, 249, 0.40);
    --color-translucent-dark-wash: rgba(13, 17, 33, 0.40);
  }
`;
